<template>
  <div class="career_title">
    <label
      id="careerTitle"
      class="head_txt module_type_name ace_sec_hd"
      role="heading"
      :aria-label="'Career ' + career.name">
        {{career.name}}
    </label>

    <template v-if="career && career.uuid && isBookmarkEnabled">
      <span
        v-if="isBookmarked(career)" @click.stop.prevent="deleteCareerBookmark(career)"
        class="ic_bm_container bookmarked ace_sec_txt"
        title="remove this career from bookmark">
          <span class="ic8-bookmark3"></span>
      </span>
      <span v-else
        @click.stop.prevent="bookmarkCareer(career)"
        class="ic_bm_container ace_sec_txt"
        title="bookmark this career">
          <span class="ic8-bookmark3"></span>
      </span>
    </template>

    <b-popover target="careerTitle" triggers="hover" placement="top" class="title_popup" container="careerNameContainer">
      <div class="title_container">
        Career: {{career.name}}
      </div>
    </b-popover>
    <div id="careerNameContainer" class="title_container_popup"></div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapActions, mapState } from 'vuex'
  import { StorageFactory } from '../../../storageFactory'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'career-title',
    props: ['career'],
    data: () => {
      return {
        userId: localStore.getItem('userid')
      }
    },
    computed: {
      ...mapState({
        'bookmarks': state => state.explore.bookmarks,
        'packages': state => state.institution.packages,
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      isBookmarkEnabled () {
        let bookmarkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
        if (bookmarkFeature && bookmarkFeature.enabled) {
          return true
        }
        return false
      }
    },
    methods: {
      ...mapActions([
        'loadAllBookmarks',
        'loadCreateBookmarks',
        'loadDeleteBookmark'
      ]),
      getBookmark (career) {
        let target = _.find(this.bookmarks, (bookmark) => {
          return (bookmark.entityUuid === career.uuid)
        })
        return target
      },
      isBookmarked (career) {
        career.bookmark = this.getBookmark(career)
        return career.bookmark && career.bookmark.uuid
      },
      async bookmarkCareer (career) {
        const bookmark = {
          source: 'explore',
          entityType: 'career',
          entityTitle: career.name,
          entityUuid: career.uuid,
          userId: this.userId
        }
        const response = await this.loadCreateBookmarks(bookmark)
        const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + career.name + '\''
        const notify = response ? this.notifySuccess : this.notifyFailure
        notify(message)
        await this.loadAllBookmarks()
      },
      async deleteCareerBookmark (career) {
        await this.loadDeleteBookmark(career.bookmark.uuid)
        this.notifySuccess('Successfully deleted bookmark \'' + career.name + '\'')
        await this.loadAllBookmarks()
      },
      notifySuccess (text) {
        return this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        return this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/career/components/CareerTitle.vue